import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykmjtqcawm: FaireProductEntity = {
  token: "p_ykmjtqcawm",
  type: "product",
  name: "SURFSKATE DIAMOND",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl: "https://cdn.faire.com/fastly/c0f4d4d7fedae7110cc824b02d38eb93af07bf0879a9ffbeb7988d7b0af2a1bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5cd3f51d9acde4b56b0d5ac5bfadf6ec596816cacf9c0f7b85ac1feca015fd36.jpeg",
    "https://cdn.faire.com/fastly/571c00c247d39089cd7708085cc7f190c56c8af27b60891087675a3b87cbc7ca.jpeg",
    "https://cdn.faire.com/fastly/4a3e34f419c7fba9ce448ac4e8315537cf06660f00e4805372eb6d46b5d3293d.jpeg",
    "https://cdn.faire.com/fastly/498fbd142f189699051a12c699fa57f285eb99cc92836812e4ef26a367dc2912.jpeg",
    "https://cdn.faire.com/fastly/d84448020843b3487a00b6ab031af99c35b96367da0f8a402bc6baf3343920eb.jpeg",
    "https://cdn.faire.com/fastly/b9507888b5ed8310699580bbe93302b22e1ca7838938f2d225fd19cf9d4d246a.jpeg",
    "https://cdn.faire.com/fastly/bc193a5624a97850c23541ce2e5683ef6ff8d2dbaf2308ccbbe88dd836ddffe9.jpeg",
    "https://cdn.faire.com/fastly/6ca097efc318eee7cf1b4d7a4ac892944de1e67b1e426ca4c1763b23e2fdb684.jpeg",
    "https://cdn.faire.com/fastly/60912c2162307ae0ab4b165c43ebc6264fa00826e3abf179cbb80cbeb00fe3cb.jpeg",
    "https://cdn.faire.com/fastly/1399a0bb3bb357ab3468647cbc1899da5caec15593f730663d0d9c7ec1be37a8.jpeg"
  ],
  priceDollars: 151.67,
  description: "Dimensions: 32x9.9 inch\n\nWB: 17.6-18.5 inches Variable Wheelbase\n\nThe Hydroponic DIAMOND has been manufactured with 7 plies of Canadian Hard Rock Maple and Epoxy Resin. Old School Skate deck featuring a surfboard diamond shape, with nice concave and a pointy nose. The Hydroponic DIAMOND lets you ride your skateboard as if you were truly surfing your board in the sea. You will need to position your weight on the back truck, so you can feel the ‘Fin Effect’ and gain stability while keeping the 360 turning sensations thanks to the rotating front truck.\n\nThe corners of the diamond tail make its turning characteristics a bit more pivotal and sharper than the rounded tail.\n\nTrucks: Surf Skate Trucks 160 mm Bushings: 82A Barrel + Cone / EXTRA SET 85A Barrel + Cone Wheels: BUDDHA WHEELS ARENAS Orange, Center Set, 65 x 45 mm, 80A\n\nBearings: HYDROPONIC ABEC 7 with Spacers\n\n*Wheels may vary in color due to stock variations",
  tags: [],
  msrpDollars: 303.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:09.430Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
